module.exports = __webpack_public_path__ + "static/media/dx_image.a0089ea7.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/dx_image.png
// module id = 491
// module chunks = 0